import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { KindTag } from './KindTag';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Project } from '../../hooks/useProjects';
type WorkTileProps = {
  project: Project;
  onOpen?: () => void;
  viewLabel: string;
};
export function WorkTile({
  project,
  onOpen,
  viewLabel
}: WorkTileProps) {
  const {
    t
  } = useLanguage();
  const kindLabel = t.common.kinds[project.kind];
  if (!project.image) {
    return <article className="flex h-full flex-col" data-id="element-399" data-mp="29zg1o8vj3hka">
        <PhotoPlaceholder label={t.common.placeholder} className="aspect-[4/5] w-full" data-id="element-400" data-mp="1vyde1rovxz79" />
        <div className="flex flex-1 flex-col pt-4" data-id="element-401" data-mp="1zzp7676yx2k7">
          <h3 className="font-display text-lg font-semibold text-ink/60" data-id="element-402" data-mp="200gt0qarjlxa">{project.title}</h3>
          <p className="mt-1 text-sm text-ink/50" data-id="element-403" data-mp="3qdfz9d6wiv4d">{project.description}</p>
        </div>
      </article>;
  }
  return <article className="flex h-full flex-col" data-id="element-404" data-mp="3ucx2s12rpi6w">
      <button type="button" onClick={onOpen} aria-label={`${viewLabel}: ${project.title}`} className="group relative block aspect-[4/5] w-full overflow-hidden rounded-2xl bg-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-mauve focus-visible:ring-offset-2" data-id="element-405" data-mp="8xnhrvltzmly">
        <img src={project.image} alt={project.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.04]" data-id="element-406" data-mp="dpx5r63dycll" />
        <span className="absolute left-3 top-3" data-id="element-407" data-mp="3h7fcfa7f9dkf">
          <KindTag kind={project.kind} label={kindLabel} data-id="element-408" data-mp="3w3ehebz8ixlc" />
        </span>
      </button>
      <div className="flex flex-1 flex-col pt-4" data-id="element-409" data-mp="3r3s82dmj21ht">
        <h3 className="font-display text-lg font-semibold text-ink" data-id="element-410" data-mp="3r27a0e1080f7">{project.title}</h3>
        <p className="mt-1 text-sm leading-relaxed text-ink/65" data-id="element-411" data-mp="1bbbb00328hpu">{project.description}</p>
        <button type="button" onClick={onOpen} className="group mt-auto inline-flex items-center gap-1.5 self-start pt-3 text-sm font-medium text-mauve transition-colors duration-150 ease-smooth hover:text-mauve-deep" data-id="element-412" data-mp="16chvy384kink">
          {viewLabel}
          <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-413" data-mp="1nedzctmh8zge" />
        </button>
      </div>
    </article>;
}